import React, {Component} from 'react';
import {connect} from 'react-redux';
import {mapObjIndexed, assocPath, not, compose, values, any, pick, path, append, map} from 'ramda';

import Box from 'components/box';
import Input from 'form/input';
import Checkbox from 'form/checkbox';
import Textarea from 'form/textarea';
import {Error} from 'components/errors';
import {Label, Divider, SelectWithSearchAsync, RequiredSpan} from 'components/common';
import {PageHead} from 'components/header/components';
import {ButtonDefault} from 'components/buttons';
import Spinner from 'spinner';

import ReactModal from 'react-modal';
import {Modal, CloseModal, ModalContent} from 'components/modal';
import {ButtonSuccessModal, ButtonDangerModal, ButtonWrap} from 'components/buttons';

import { toCurrency } from 'utils/toCurrency'

import {searchServices} from 'redux/actions/admin/services';
import {loadInstitutionDetail} from "redux/actions/portal/institutions";
import { addServiceToInstitution, cleanInstitutionServiceDetailStore, loadInstitutionServiceDetail, serviceInstitutionProcessFailed } from 'redux/actions/admin/institution';

import close from 'images/general/close.svg';

const mapStateToProps = (state) => ({
  servicesList: state.adminService.get('servicesList'),
  institutionDetail: state.institutions.get('institutionDetail'),
  serviceDetail: state.adminInstitution.get('serviceInstitution'),
  isLoading: state.institutions.get('institutionsIsLoading') || state.adminInstitution.get('bindingsLoading') || state.adminService.get('servicesIsLoading'),
  isSubmitting: state.institutions.get('bindingsSubmitting'),
  hasError: state.adminInstitution.get('serviceInstitutionProcessFailed')
})

const mapDispatchToProps = dispatch => ({
  addServiceToInstitution: (serviceData, institutionId, serviceInstitutionId) =>
    dispatch(addServiceToInstitution(serviceData, institutionId, serviceInstitutionId)),
  loadServicesList: search => dispatch(searchServices(search)),
  loadCurrentInstitution: institutionId => dispatch(loadInstitutionDetail(institutionId)),
  loadInstitutionService: serviceInstitutionId => dispatch(loadInstitutionServiceDetail(serviceInstitutionId)),
  cleanServiceDetail: () => dispatch(cleanInstitutionServiceDetailStore()),
  cleanError: () => dispatch(serviceInstitutionProcessFailed(false))
})

class AddService extends Component {
  state = {
    serviceData: {
      cabinet_number: "",
      phone: "",
      service_classification: "",
      is_payment: false,
      comment: "",
      price: '',
      instruction: "",
      schedule: ""
    },
    errors: {
      cabinet_number: false,
      phone: false,
      service_classification: false,
      is_payment: false,
      comment: false,
      price: false,
      instruction: false,
      schedule: false
    },
    formValid: true,
    modalOpen: false,
    isEditMode: false,
    serviceSelect: ''
  }

  selectWithSearchStyle = () => ({
    border: path(['errors', 'service_classification'], this.state) ? "solid 1px #7f1414" : "none"
  })

  generatePageTitle = () => {
    const defaultTitle = 'Установа не визначена'
    const fetchedInstitutionTitle = this.props.institutionDetail
      ? this.props.institutionDetail.get('short_title')
      : defaultTitle
    const institutionTitle = path(['location', 'state', 'institutionTitle'], this.props) || fetchedInstitutionTitle
    return `${institutionTitle}: налаштування послуг`
  }

  isEditMode = () => Boolean(this.props.match.params.service_id) //that means component is in 'edit' mode

  getValue = key => path(['serviceData', key], this.state)

  getError = key => path(['errors', key], this.state)

  onValueChange(value, key, errorValue = false) {
    let createNewState = compose(assocPath(['serviceData', key], value), assocPath(['errors', key], errorValue))
    this.setState(prevState => createNewState(prevState))
  }

  onChangeService = service => {
    if(!service) service =  { value: '' }
    this.onValueChange(service.value, 'service_classification')
    this.setState(() => ({serviceSelect: service}))
  }

  onChangePayment = event => {
    this.onValueChange(event.target.checked, 'is_payment')
    if(not(event.target.checked)) {
      this.onValueChange('', 'price', false)
    }
    if(event.target.checked && not(this.state.formValid)) {
      this.onValueChange('', 'price', true)
    }
  }

  onChangePrice = event => {
    this.onValueChange(event.target.value, 'price')
  }

  onBlurPrice = event => {
    const valueToCurrency = toCurrency(event.target.value)
    if(valueToCurrency) {
      this.setState(() => ({ priceFieldError: false }))
    } else {
      this.setState(() => ({ priceFieldError: true }))
      this.onValueChange('', 'price')
    }
  }

  onChangeSchedule = event => {
    this.onValueChange(event.target.value, 'schedule')
  }

  onChangeCabinet = event => {
    this.onValueChange(event.target.value, 'cabinet_number')
  }

  onChangePhone = event => {
    this.onValueChange(event.target.value, 'phone')
  }

  onChangeInstruction = event => {
    this.onValueChange(event.target.value, 'instruction')
  }

  onChangeComment = event => {
    this.onValueChange(event.target.value, 'comment')
  }

  onSubmit = async (event) => {
    event.preventDefault()
    let requiredFields = ['service_classification']
    const isPayment = path(['serviceData', 'is_payment'], this.state)
    if(isPayment) requiredFields = append('price', requiredFields)
    await this.validateForm(requiredFields)
    if(not(this.state.formValid)) return
    const serviceInstitutionId = path(['match', 'params', 'service_id'], this.props)
    let dataToSend = this.state.serviceData
    if (not(isPayment)) {
      dataToSend.price = 0
    } else {
      dataToSend.price = parseFloat(dataToSend.price, 10).toFixed(2)
    }
    this.props.addServiceToInstitution(dataToSend, this.state.institutionId, serviceInstitutionId)
  }

  validateForm(requiredFields = null) {
    let fields = requiredFields ? pick(requiredFields, this.state.serviceData) : this.state.serviceData
    let errors = {}
    mapObjIndexed((value, key) => {
      let valueError = !value
      errors = assocPath([key], valueError, errors)
    }, fields)
    let isInvalid = value => Boolean(value)
    if(any(isInvalid, values(errors))) {
      this.setState(() => ({ errors, formValid: false }))
    } else {
      this.setState(() => ({ errors, formValid: true }))
    }
  }

  openModal = () => {
    const isFalse = value => Boolean(value)
    if(any(isFalse, values(this.state.serviceData))){
      this.toggleModal()
      return
    }
    this.props.history.goBack()
  }

  toggleModal = () => this.setState(prevState => ({modalOpen: !prevState.modalOpen}))

  onModalOk = () => {
    this.toggleModal()
    this.props.history.goBack()
  }

  generateServiceOptions = results => {
    return results.reduce((arr, item) => {
      const newOption = {value: item.get('id'), label: item.get('title')}
      arr.push(newOption)
      return arr
    }, [])
  }

  loadServices = (search = '') => {
    return this.props.loadServicesList(search)
      .then(response => {
        const results = response.get('results')
        if(!results.size) return Promise.resolve({ options: [] })
        const options = this.generateServiceOptions(results)
        return { options }
      })
  }

  componentDidMount() {
    this.props.cleanError()
    const institutionId = path(['match', 'params', 'institution_id'], this.props)
    const institutionTitle = path(['location', 'state', 'institutionTitle'], this.props)
    if(not(this.props.institutionDetail) && not(institutionTitle)){
      this.props.loadCurrentInstitution(institutionId)
    }
    this.setState(() => ({ institutionId }))

    if (this.isEditMode() && this.props.serviceDetail.size > 0) { //that means its 'edit' mode
      const keys = [
        'cabinet_number', 'phone', 'service_classification', 'is_payment', 'comment', 'price', 'instruction', 'schedule'
      ]
      let newState = {}
      const createNewState = key => {
        newState = {...newState, [key]: this.props.serviceDetail.get(key)}
      }
      map(createNewState, keys)
      this.setState(() => ({
        serviceData: newState,
        serviceSelect: {value: this.props.serviceDetail.getIn(['service_data', 'code']), label: this.props.serviceDetail.getIn(['service_data', 'title'])}
      }))
    }

    if (!this.props.serviceDetail.size && this.props.match.params.service_id) { //that means component is in 'edit' mode
      this.props.loadInstitutionService(this.props.match.params.service_id)
    }

    if(this.isEditMode() && not(this.state.isEditMode)){
      this.setState(() => ({isEditMode: true}))
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.serviceDetail.size > 0 && not(this.state.serviceData.service_classification) && nextProps.match.params.service_id) { //that means 'edit' mode and props must be spread to state + 'edit' mode
      const keys = [
        'cabinet_number', 'phone', 'service_classification', 'is_payment', 'comment', 'price', 'instruction', 'schedule'
      ]
      let newState = {}
      const createNewState = key => {
        newState = {...newState, [key]: nextProps.serviceDetail.get(key)}
      }
      map(createNewState, keys)
      this.setState(() => ({
        serviceData: newState,
        serviceSelect: {value: nextProps.serviceDetail.getIn(['service_data', 'code']), label: nextProps.serviceDetail.getIn(['service_data', 'title'])}
      }))
    }

    if(this.isEditMode() && not(this.state.isEditMode)){
      this.setState(() => ({isEditMode: true}))
    }
  }

  componentWillUnmount () {
    this.props.cleanServiceDetail()
  }

  render() {
    if (this.props.isLoading || this.props.isSubmitting) return <Spinner/>

    return (
      <div>
        <PageHead>
          <h2>{this.generatePageTitle()}</h2>
        </PageHead>

        <Box title4={path(['location', 'state', 'institutionTitle'], this.props) ? "Додавання послуги" : "Редагування послуги"}>
          <form onSubmit={this.onSubmit}>

            <Divider>
              <Label>Назва послуги: <RequiredSpan hasError={this.getError('service_classification')}>*</RequiredSpan></Label>
              <SelectWithSearchAsync
                searchable={true}
                isSearchable={true}
                disabled = {this.isEditMode()}
                isDisabled = {this.isEditMode()}
                onChange={this.onChangeService}
                value={this.state.serviceSelect}
                loadOptions={this.loadServices}
                valueKey={'value'}
                labelkey={'label'}
                required
                hasError={this.getError('service_classification')}
                style={this.selectWithSearchStyle()}
                placeholder="Починайте вводити для пошуку..."
                noResultsText="Немає результатів"
              />
            </Divider>

            <Divider>
              <Checkbox
                type="checkbox"
                label="Послуга платна"
                checked={this.getValue('is_payment')}
                onChange={this.onChangePayment}
              />
            </Divider>

            <Divider>
              <Input
                label="Вартість послуги (у грн.):"
                placeholder="Якщо послуга платна, введіть вартість послуги у грн."
                hintMsg={this.state.priceFieldError ? 'Допустимий формат значень: 00.00' : ''}
                disabled = {not(this.getValue('is_payment'))}
                required={this.getValue('is_payment')}
                value={this.getValue('price')}
                hasError={this.getError('price')}
                onChange={this.onChangePrice}
                onBlur={this.onBlurPrice}
              />
            </Divider>

            <Divider>
              <Textarea
                label="Графік роботи:"
                value={this.getValue('schedule')}
                hasError={this.getError('schedule')}
                max={2000}
                placeholder="Години роботи, розклад"
                onChange={this.onChangeSchedule}
              />
            </Divider>

            <Divider>
              <Input
                label="Кабінет:"
                max={255}
                value={this.getValue('cabinet_number')}
                hasError={this.getError('cabinet_number')}
                placeholder="Номер кабінету"
                onChange={this.onChangeCabinet}
              />
            </Divider>

            <Divider>
              <Input
                label="Телефон"
                max={255}
                value={this.getValue('phone')}
                hasError={this.getError('phone')}
                onChange={this.onChangePhone}
              />
            </Divider>

            <Divider>
              <Textarea
                label="Необхідні приготування:"
                max={2000}
                value={this.getValue('instruction')}
                hasError={this.getError('instruction')}
                placeholder="Як готуватись до послуги?"
                onChange={this.onChangeInstruction}
              />
            </Divider>

            <Divider>
              <Textarea
                label="Додаткові відомості:"
                value={this.getValue('comment')}
                max={511}
                hasError={this.getError('comment')}
                onChange={this.onChangeComment}
              />
            </Divider>

            <Divider/>
            <ButtonDefault disabled = {this.props.isSubmitting} type="submit" value="Зберегти"/>
            <ButtonDefault onClick={this.openModal} value="Вийти без збереження"/>
          </form>

          {
            this.props.hasError && <Error>
              При збереженні даних виникла проблема. Перевірте, будь ласка, всі поля.
            </Error>
          }
        </Box>

        <ReactModal isOpen={this.state.modalOpen} onRequestClose={this.toggleModal}
                    className={{
                      base: 'modalContent',
                      afterOpen: 'myClass_after-open',
                      beforeClose: 'myClass_before-close'
                    }} contentLabel="Підтвердження запису"
                    overlayClassName={{
                      base: 'modalOverlay',
                      afterOpen: 'myOverlayClass_after-open',
                      beforeClose: 'myOverlayClass_before-close'
                    }}>
          <div>
            <Modal>
              <CloseModal>
                <div>
                  <img src={close} alt="закрити" onClick={this.toggleModal} />
                </div>
              </CloseModal>

              <ModalContent>
                <h3>
                  Ви впевнені, що хочете вийти без збереження?
                  Всі внесені зміни будуть скасовані
                </h3>
                <ButtonWrap>
                  <ButtonSuccessModal onClick={this.onModalOk} value="Так"/>
                  <ButtonDangerModal value="Ні" onClick={this.toggleModal}/>
                </ButtonWrap>
              </ModalContent>

            </Modal>
          </div>
        </ReactModal>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddService);



// WEBPACK FOOTER //
// ./src/admin/institutions/add-service.js